const actionTypes = require('../loansConstants/actionTypes');
const { APIGet } = require('utilities/APIRequestHelper');

const fetchLoanMovementsDetails = movementId => ({
    type: actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS,
    payload: {
        movementId
    }
});

const fetchLoanMovementsDetailsSuccess = (movementId, data) => ({
    type: actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS_SUCCESS,
    payload: {
        movementId,
        data
    }
});

const fetchLoanMovementsDetailsFailure = (movementId, error) => ({
    type: actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS_FAILURE,
    payload: {
        movementId,
        error: error.description
    }
});

const requestLoanMovementsDetails = movementId => (dispatch, getState) => {
    const movement = getState().loansMovements.getIn(['byId', movementId]);
    const loan = getState().loans.getIn(['byId', movement.get('loanId')]);

    const detailsRequestData = {
        query: {
            codigoProducto: movement.get('productCode'),
            numeroContrato: loan.get('newContractNumber'),
            producto: loan.get('newProduct'),
            fechaMovimiento: movement.get('movementDate'),
            fechaValor: movement.get('valueDate'),
            divisa: movement.getIn(['amount', 'currency']),
            importe: movement.getIn(['amount', 'amount']),
            numeroSecuenciaOperacion: movement.get('operationSequenceNumber'),
            operacionBancaria: movement.getIn(['bankOperation', 'bankOperation']),
            operacionBasica: movement.getIn(['bankOperation', 'basicOperation']),
            codigoTerminalDgo: movement.getIn(['DGOOperation', 'dgoTerminalCode']),
            numeroDgo: movement.getIn(['DGOOperation', 'dgoNumber'])
        }
    };

    dispatch(fetchLoanMovementsDetails(movementId));

    return APIGet({dispatch, endpoint: 'loansAndMortgagesMovementsDetails', params: detailsRequestData})
        .then(response => dispatch(fetchLoanMovementsDetailsSuccess(movementId, response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(fetchLoanMovementsDetailsFailure(movementId, response.error));
            } else {
                throw response;
            }
        });
};

module.exports = { requestLoanMovementsDetails };
